
import { WorkspaceOrder } from '@/@types/WorkspaceOrder';
import { Component, Prop } from 'vue-property-decorator';
import VueApp from '@/@types/app/VueApp';
import { Workspace } from '@/models/Workspace';
import { ArticleEditMode } from '@/@types/ArticleEditMode';
import { WorkspaceView } from '@/@types/WorkspaceView';

@Component({
  components: {
    SidebarGroupItem: () => import('./SidebarGroupItem.vue'),
    SidebarArticleItem: () => import('../SidebarArticleItem/SidebarArticleItem.vue'),
  },
})
export default class SidebarNestedGroupItem extends VueApp {
  @Prop(Object) groupNode: WorkspaceOrder;
  @Prop(Object) workspace!: Workspace;
  @Prop(Object) workspaceView!: WorkspaceView;
  @Prop(String) articleMode?: ArticleEditMode;

  @Prop(Boolean) isMobileView!: boolean;
  @Prop(Boolean) isSharedMode!: boolean;
  @Prop(Boolean) showArchivedArticles!: boolean;

  @Prop(Array) expanded: string[];

  @Prop({ default: 1 }) nested: number;
  @Prop({ default: 0 }) paragraphProgress: number;
  @Prop() recalculateSidebarHeight: () => void;
  @Prop({ default: false }) isInsideIntegration: boolean;

  toggleExpand(item: any) {
    this.$emit('toggle-expand', item);
  }

  navigateToFirstArticle(payload: any) {
    this.$emit('navigate-to-first-article', payload);
  }

  hasArticle(order: WorkspaceOrder) {
    const foundArticle = this.workspaceView.articles.filter((article) => {
      return article.id === order.value;
    });
    if (foundArticle.length > 0) {
      return foundArticle[0];
    }
    return null;
  }
}
